import Storage from 'utils/localStorage/Storage';

const SESSION_EXPIRY = Storage.DAYS * 60;
const SUPERCHAT_CONFIG_EXPIRY = Storage.DAYS * 1;

const KEYS = {
    GENAI_SESSION_KEY: 'GENAI_SESSION',
    SUPERCHAT_CONFIG_KEY: 'SUPERCHAT_CONFIG'
};

const setGENAISession = session => {
    Storage.local.setItem(KEYS.GENAI_SESSION_KEY, session, SESSION_EXPIRY);
};

const setSuperChatConfig = config => {
    try {
        Storage.local.setItem(KEYS.SUPERCHAT_CONFIG_KEY, JSON.stringify(config), SUPERCHAT_CONFIG_EXPIRY);
    } catch (error) {
        Sephora.logger.error('SuperChat: Error creating Super Chat Config in LocalStorage');
    }
};

const getGENAISession = () => {
    const existingSession = Storage.local.getItem(KEYS.GENAI_SESSION_KEY);

    return existingSession;
};

const getSuperChatConfig = () => {
    const existingConfig = Storage.local.getItem(KEYS.SUPERCHAT_CONFIG_KEY);

    try {
        return JSON.parse(existingConfig);
    } catch (error) {
        return null;
    }
};

export {
    setGENAISession, getGENAISession, setSuperChatConfig, getSuperChatConfig
};
